export const KEY_STORE_DRAFT = "nftstudios_backoffice_draft";
